import { formatDataBeforeSend } from "helpers/GeneralHelper";
import { updateRecruitment } from "model/AboutUsModel";
import { updateFetchDetails } from "model/Partners";
import React, { useEffect, useState, useRef } from "react";
import { Button, FormGroup, Input, Label, Modal, ModalBody, Spinner } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import * as Yup from "yup";
import { useUserContext } from "libs/context/UserContext";
import InputMask from "react-input-mask";
import { Offcanvas } from "bootstrap";
import CandidateTrackApplication from "pages/CandidateTrackApplication/candidate-track-application";
import { candidateNotInterested, candidateUpdateAllData, candidateUpdateProfileData } from "model/CandidateDetailsModel";


const NotInterestedCommonButton = () => {
   const inputFields = {
     Notes: ''
     };
     const formatOptions = [];
   
     const [fields, setFields] = useState(inputFields);
     const [errors, setErrors] = useState({});
     const [touched, setTouched] = useState({});
     const [submitLoading, setSubmitLoading] = useState(false);
     const [interestedNotes, setNotInterestedNotes] = useState(false);

   
     const closeModal = () => setNotInterestedNotes(false);
   
     const { candidateDetailsData, fetchCandidateDetailsDataForUpdate, fetchCandidateDetailsData } = useUserContext() || {};
     
   
     // ✅ Yup validation schema
     const validationSchema = Yup.object().shape({
       Notes: Yup.string().required("Notes are required"),
     });
   
     // Handle input change + validate field
     const handleChange = async (e) => {
       const { name, value } = e.target;
       setFields({ ...fields, [name]: value });
   
       try {
         await Yup.reach(validationSchema, name).validate(value);
         setErrors((prev) => ({ ...prev, [name]: "" }));
       } catch (err) {
         setErrors((prev) => ({ ...prev, [name]: err.message }));
       }
     };
   
     const handleBlur = (e) => {
       const { name } = e.target;
       setTouched({ ...touched, [name]: true });
     };
   
     const handleSubmit = async (e) => {
       e.preventDefault();
       setSubmitLoading(true);
   
       try {
         await validationSchema.validate(fields, { abortEarly: false });
         setErrors({});
   
         const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
         formData.append('candidateClientId', candidateDetailsData?.candidateClientId)
        let response = await candidateNotInterested(formData)
   
         if (response?.IsSuccess) {
           toast.success(response?.Message);
           localStorage?.setItem("InterestedOrNot", "Not-Interested")
           setFields(inputFields);
           fetchCandidateDetailsData()
           closeModal();
           setFields(inputFields);
         } else {
           toast.error("Failed to submit callback request");
         }
       } catch (err) {
            toast.error(err);
       } finally {
         setSubmitLoading(false);
       }
     };

    return (
        <>

            <div className="row justify-content-center">
                <div className="col-auto">
                    <button className="btn btn-primary-1" onClick={(e) => setNotInterestedNotes(true)}>Not Interested Anymore</button>
                </div>
            </div>

            <Modal
      isOpen={interestedNotes}
      toggle={closeModal}
      backdrop="static"
      centered

    >
      <ModalBody className="p-4 d-flex flex-column" style={{ height: "100vh" }}>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold mb-0">Not Interested Anymore</h5>
          <Button close onClick={closeModal} />
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="flex-grow-1 d-flex flex-column">
          <div className="flex-grow-1 overflow-auto pe-2">
            <FormGroup>
              <Label>Feedback</Label>
              <Input
                type="textarea"
                name="Notes"
                placeholder="Enter Feedback"
                value={fields.Notes}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {(touched.Notes || errors.Notes) && (
                <div className="text-danger small">{errors.Notes}</div>
              )}
            </FormGroup>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button color="secondary" onClick={closeModal} type="button">
              Cancel
            </Button>
            <Button color="dark" type="submit" disabled={submitLoading}>
              {submitLoading ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Submitting...
                </>
              ) : (
                "Submit"
              )}
            </Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
        </>
    );
};

export default NotInterestedCommonButton;
